import React, { useCallback, useEffect, useState } from 'react';
import { unwrapResult } from '@reduxjs/toolkit';
import { useHistory, useParams } from 'react-router';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { toast } from 'react-toastify';

import '../CreateCampaign/createCampaign.scss';
import CustomButton from '../../../uiKit/Button/CustomButton';
import Title from '../../../uiKit/Title/Title';
import { Breadcrumb } from '../../../components/Breadcrumbs/breadcrumbs';
import CampaignMessages from './HelperComponents/campaignMessages';
import CampaignsInfos from './HelperComponents/campaignInfos';

import {
    clearCampaigns,
    createCampaign,
    createCampaignDraft,
    getStoppedCampaign,
} from '../../../redux/state/campaignSlice';
import { setTabType } from '../../../redux/state/communitySlice';

const RepeatCampaign = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const { campaignId } = useParams();

    const isLoading = useSelector(state => state.campaign.isLoading.getStoppedCampaign, shallowEqual);
    const communityId = useSelector(state => state.community.community.id, shallowEqual);

    const [draftMessages, setDraftMessages] = useState(null);
    const [messages, setMessages] = useState(null);
    const [excludedMembers, setExcludedMembers] = useState([]);

    const [editedCampaign, setEditedCampaign] = useState({
        id: null,
        name: '',
        campaignTypeId: 0,
        recipient: {
            id: null,
            fullName: null
        },
        amount: 0,
        recipientId: null,
        description: '',
        excludedMembers: [],
        campaignUrgencyType: 1,
    });

    useEffect(() => {
        if (!!communityId && !!campaignId) {
            dispatch(getStoppedCampaign({ communityId, campaignId }))
                .then(unwrapResult)
                .then(response => {
                    const {
                        id,
                        name,
                        campaignTypeId,
                        recipient,
                        recipientId,
                        amount,
                        description,
                        messages,
                        excludedMembers,
                    } = response.campaign;
                    const ids = excludedMembers.map(member => member.userId);
                    const campaignUrgencyType = response.campaign.campaignUrgencyType.id;
                    setEditedCampaign({
                        id,
                        name,
                        campaignTypeId,
                        recipient,
                        amount,
                        recipientId,
                        description,
                        campaignUrgencyType,
                        excludedMembers: ids
                    })
                    setExcludedMembers(excludedMembers);
                    setDraftMessages(messages);
                })
                .catch(({ title }) => toast.info(title))
        }
    }, [communityId, campaignId, dispatch])

    const saveHandler = () => {

        const data = { ...editedCampaign, communityId, messages }

        dispatch(createCampaign({ communityId, data }))
            .then(unwrapResult)
            .then((response) => {
                dispatch(clearCampaigns());
                setTimeout(() => {
                    history.push(`/campaigns/campaign/active/${communityId}/${response.campaign.id}`);
                }, [1000])
            })
            .catch(({ title }) => {
                window.scrollTo(0, 0);
                toast.info(`Creation of campaign failed: ${title}`)
            })
    }

    const saveDraftHandler = () => {

        const data = { ...editedCampaign, communityId, messages }

        dispatch(createCampaignDraft({ communityId, data }))
            .then(unwrapResult)
            .then(() => {
                dispatch(setTabType(6));
                history.push(`/communities/community/${communityId}`)
            })
            .catch(({ title }) => {
                window.scrollTo(0, 0);
                toast.info(`Saving draft failed: ${title}`)
            })
    }

    const updateMessages = useCallback((newMessages) => setMessages(newMessages), [])

    return (
        <>
            <Breadcrumb title={'Repeat Campaign'} />
            <div className='campaignTitle'>
                <Title
                    text='Repeat a campaign'
                    fontSize={32}
                    lineHeight={40}
                />
            </div>
            <div className='titleInputWrapper'>
                <CampaignsInfos
                    campaign={editedCampaign}
                    setCampaign={setEditedCampaign}
                    excluded={excludedMembers}
                />
                <div className='divider' style={{ marginBottom: '8px' }} />
                <CampaignMessages
                    messages={draftMessages}
                    updateMessages={updateMessages}
                    isLoading={isLoading}
                />
                <div className='divider' />
                <div className='createCampaignButtons' >
                    <CustomButton
                        title='Launch'
                        style={{ marginBottom: '16px' }}
                        classNames='mr16to0'
                        onClick={saveHandler}
                    />
                    <CustomButton
                        isWhite
                        title='Save as Draft'
                        onClick={saveDraftHandler}
                    />
                </div>
            </div >
        </>
    )
}

export default RepeatCampaign;